<template>
	<NewDesignModal :title="titleName" @dismiss="$emit('dismiss')">
		<div class="player-container">
			<DailyMotionPlayer
				class="player"
				:clip="clip"
				:isBackdrop="false"
				:isActive="true"
				:title="title"
				:additionalContexts="additionalContexts"
				playerId="x10mxm"
			></DailyMotionPlayer>
			<JWTVProFooter v-if="showJWTVProFooter" :additionalContexts="additionalContexts" :title="title" />
		</div>
	</NewDesignModal>
</template>

<script lang="ts" setup>
import { Offer } from '@/@types/graphql-types';
import NewDesignModal from '@/components/modals/vfm/NewDesignModal.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed } from 'vue';
import DailyMotionPlayer from '@/ui-components/players/DailyMotionPlayer.vue';
import { isBitMovinCountry } from '@/helpers/trailer-helper';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { isProWebCountry } from '@/helpers/pro-web-helper';
const JWTVProFooter = defineAsyncComponent(() => import('@/pages/titleDetailV1/v1/hero/JWTVProFooter.vue'));

const props = withDefaults(
	defineProps<{
		offer: Offer;
		title?: TitleDetail;
		additionalContexts?: SnowplowContext[];
	}>(),
	{
		title: undefined,
	}
);
const { isPremium } = storeToRefs(useUserStore());
const { country, webLocale } = storeToRefs(useLanguageStore());

const showJWTVProFooter = computed(() => {
	return !isPremium.value && isProWebCountry(webLocale.value);
});

const titleName = computed(() =>
	props.title?.__typename == 'Season' ? props.title?.show?.content.title : props.title?.content.title
);

const clip = computed(() => ({
	provider: 'JUSTWATCH_TV',
	externalId: props.offer.id,
	sourceUrl: isBitMovinCountry(country.value)
		? props.offer.streamUrlExternalPlayer ?? props.offer.streamUrl
		: props.offer.streamUrl,
}));
</script>

<style lang="scss" scoped>
.player-container {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	.player {
		height: 100%;
		width: 100%;
		padding: 20px;
		max-height: 100% !important;
		:deep(.youtube-player__video-container) {
			height: 100%;
		}
	}
}
</style>
